<template>
  <el-container class="show-body" v-if="hide">
    <div style="text-align:right;" v-if="items.length">
      <template >
        <el-button type="primary" style="width:150px;" @click="competitionPost" v-if="!is_post">交卷</el-button>
        <el-button type="info" style="width:150px;" v-else-if="is_post">已交卷</el-button>
      </template>
    </div>
    <template v-for="( item , index ) in items">
    <div :name="index" class="items-group" :key="index" v-if="item.project.length">
      <h2 class="target-title"><span>{{item.target_title}}</span>
        <template v-if="is_post&&!user_role">
        <span v-if="!is_post">{{calcProgress(item.event_done,item.total_event)}}%</span>
        <span v-if="is_post">(我的得分: {{(is_published && is_examines && test_status == 2?item.score:'?')+'/'+item.percent}})</span>
        </template>
      </h2>
      <template v-for="(element,ind) in item.project">
      <div class="list-group-item" :class="isInArray(index+'-'+ind)?'':'no-bottom'" :key="ind" v-if="element.task.length">
        <div class="project-header handle" @click="setSection(index,ind)">
          <div class="project-img">
            <img :src="element.img_url?element.img_url:require('../../assets/imgs/default-icon.jpg')"/>
          </div>
          <div class="project-intro">
            <p>{{ element.project_name }}
              <span v-if="is_post&&!user_role">(我的得分: {{(is_published && is_examines && test_status == 2?element.score:'?')+'/'+element.percent}})</span>
            </p>
            <p class="introduce-text">{{element.project_desc}}</p>
          </div>
          <div class="project-progress" v-if="!user_role">
              <el-progress :percentage="calcProgress(element.event_done,element.total_event)" :color="customColorMethod" :stroke-width="12"></el-progress>
          </div>
        </div>
          <div class="task-group" v-for="(task,idx) in element.task" v-if="isInArray(index+'-'+ind)">
            <div class="task-title" :data-id="task.id">
              <span>{{ task.task_name }}</span>
              <span v-if="is_post&&!user_role">(我的得分: {{(is_published && is_examines && test_status == 2?task.score:'?')+ '/'+task.percent}})</span>
            </div>
            <div>
                <span v-for="(it , i) in task.events" class="events-item" :class="!it.is_post?'undone':''" @click="startCompetition(it.id)">
                    <el-tooltip class="item" effect="dark" :content="it.paper_title" placement="top-start">
                        <img :src="it.icon?it.icon:require('../../assets/imgs/default-icon.jpg')"/>
                    </el-tooltip>
                    <i class="next-dash" v-if="i<task.events.length-1"></i>
                </span>
            </div>
          </div>
      </div>
      </template>
    </div>
    </template>
  </el-container>
</template>
<script>
import {
  selectPathData,
  competitionPost
} from "@/api/show";
import { parse } from 'path';
export default {
  name:'index',
  components: {
    
  },
  props:['hide','replay_type','test_status','times'],
  mounted() {
    sessionStorage.removeItem('paperInfo')
    sessionStorage.removeItem('competitionId')
    this.competitionId = this.$route.params.competitionId;
    this.classroom_id = this.$route.params.classroomId;
    this.initData();
    //保存目标展开状态，编辑内容返回后要保持这种状态
    let activeNames = sessionStorage.getItem("activeNames");
    if (activeNames) {
      this.activeNames = JSON.parse(activeNames);
    }
  },
  data() {
    return {
      items: [],
      activeNames: [], //默认折叠
      classroom_id:"",//专题id
      competitionId: "", //竞赛id
      nodeNum: [],
      customColor: '#409eff',
      customColors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#6f7ad3', percentage: 100}
      ],
      end_time:0,//比赛结束时间,
      is_post:false,//是否提交比赛
      is_published:0,//是否公布成绩
      user_role:0,//是否创建者
      contest_status:this.test_status,
      is_examines:0,//是否批阅，主要用于重现赛
    };
  },
  watch: {
    activeNames: {
      deep: true,
      handler(newVal, oldVal) {
        sessionStorage.setItem("activeNames", JSON.stringify(newVal));
      }
    },
    items: {
      deep: true,
      handler(oldVal, newVal) {
        this.calcProNum();
      }
    }
  },
  
  methods: {
    initData: function() {
      let params = {
        competition_id: this.competitionId,
        replay_type:this.replay_type,
        times:this.times,
        classroom_id:this.classroom_id
      };
      selectPathData(params).then(response => {
        this.items = response.data
        this.is_post = response.status.is_post
        this.is_published = response.status.is_published
        this.is_examines = response.status.is_examines;
        this.user_role = response.status.user_role
        this.items.forEach((element,index) => {
            element.project.forEach((project,ind)=>{
              this.activeNames.push(index+'-'+ind)
            })
        });
      });
    },
    //计算项目数量
    calcProNum: function() {
      for (let i = 0; i < this.items.length; i++) {
        this.nodeNum[i] = 0;
        if (this.items[i].project && this.items[i].project.length) {
          this.nodeNum[i] = this.items[i].project.length;
        }
      }
    },
    
    //点击目标,tarIndex为目标index,index为项目index
    setSection: function(tarIndex, index) {
      let ind = tarIndex + "-" + index;
      let i = this.activeNames.findIndex(val => {
        return val === ind;
      });
      if (i === -1) {
        this.activeNames.push(ind);
      } else {
        this.activeNames.splice(i, 1);
      }
    },
    isInArray: function(value) {
      for (let i = 0; i < this.activeNames.length; i++) {
        if (value === this.activeNames[i]) {
          return true;
        }
      }
      return false;
    },
    customColorMethod(percentage) {
      if (percentage < 30) {
        return '#909399';
      } else if (percentage < 70) {
        return '#e6a23c';
      } else {
        return '#67c23a';
      }
    },
    //计算进度,total总数,donw已完成数
    calcProgress:function(done,total){
      if(!done){
        return 0
      }else{
        return Math.floor(done/total*100)
      }
    },
    //开始答题
    startCompetition:function(id){
      const params ={
        competitionId:this.competitionId,
        paperId:id,
        replay_type:this.replay_type,
        times:this.times,
        classroom_id:this.classroom_id
      }
      if(this.contest_status!==2){
              this.$router.push({
                name:'exercise',
                params
              })
          }else{
              this.$router.push({
                name:'result',
                params
              })
          }
    },
    //提交比赛
    competitionPost:function(){
      let tasks = []
      this.items.forEach((item)=>{
        item['project'].forEach((pro,index)=>{
          tasks.push(pro['task'])
        })
      })
      let events = []
      tasks.forEach((task,index)=>{
        task.forEach((evt,ind)=>{
          events.push(evt['events'])
        })
      })
      let is_done = true
      events.forEach((event,index)=>{
        event.forEach((evt,index)=>{
          if(!evt['is_post']){
            is_done = false
          }
        })
      })
      let tips = '比赛提交后不能修改活动,确定提交?'
      if(!is_done){
        tips = '还有活动未完成,确定提交?'
      }
      this.$confirm(tips,'比赛提交',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          let params = {
            competition_id:this.competitionId,
            replay_type:this.replay_type,
            times:this.times,
            classroom_id:this.classroom_id
          }
          competitionPost(params).then(response=>{
            this.is_post = 1
            this.contest_status = 2;
            this.$emit('changeStatus',2)
            this.$message.success('提交成功')
            
          })
        }).catch({})
    },
    //评委批阅
    readPaper:function(){
      if(!this.replay_type){
        this.$router.push({name:'competition-grade',params:{competitionId:this.competitionId}})
      }else if(this.replay_type===2){
        this.$router.push({name:'special-grade',params:{competitionId:this.competitionId,times:this.times,classroomId:this.classroom_id}})
      }
    }
  },
  filters: {
    NumberToChinese: function(num) {
      return NumberToChinese(num);
    }
  },
  directives: {
    focus: {
      inserted: function(el) {
        // 聚焦元素
        el.querySelector("input").focus();
      }
    }
  }
};
</script>
<style scoped>
@import url('../../assets/css/show.css');
</style>